import Vue from "vue";
import Router from "vue-router";
import login from "./views/login.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/login",
      name: "login",
      component: login
    },
    {
      path: "/",
      name: "home",
      component: () => import("./views/home.vue")
    },
    {
      path: "/product/:id",
      name: "product",
      component: () => import("./views/product.vue")
    },
    {
      path: "/diy/:id",
      name: "diy",
      component: () => import("./views/diy.vue")
    },
    {
      path: "/padh5/:id",
      name: "padh5",
      component: () => import("./views/padh5.vue")
    },
    {
      path: "/producth5/:id",
      name: "producth5",
      component: () => import("./views/producth5.vue")
    },
    {
      path: "/order/:id",
      name: "order",
      component: () => import("./views/order.vue")
    },
    {
      path: "/pay/:id",
      name: "pay",
      component: () => import("./views/pay.vue")
    }
  ]
});
